import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { PatientformService } from 'src/app/Services/PatientForms/patientform.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { configuration } from 'src/environments/environment';
import { CCDAService } from '../ccda.service';

@Component({
  selector: 'app-get-ccdamessage',
  templateUrl: './get-ccdamessage.component.html',
  styleUrls: ['./get-ccdamessage.component.css']
})
export class GetCCDAMessageComponent implements OnInit {
  CCDAForm: FormGroup;
  Sections: Array<any>;
  MessageType: Array<any>;
  PatientId: string = '';
  EncounterId: string = null;
  PatientVisitDetails: any = [];
  PatientPersonalInfo: any;
  CCDAResult: any;
  RecordRequestId: string = '';
  AddedSections: string = ''
  CCDA_HTML: string = ''
  isdirect: boolean = false;
  isDataAdded: boolean = false;
  reasonforref: boolean = false;
  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _formBuilder: FormBuilder, private _PatientformService: PatientformService
    , private toastr: ToastrService, public dialog: MatDialog, private _ccdaService: CCDAService,
    private schedulerService: SchedularServiceService,
    private spinner: NgxSpinnerService) {
    this.EncounterId = sessionStorage.getItem("encounterid");
    this.PatientId = sessionStorage.getItem("patientId");
    if (data) {
      if (this.data.patientid)
        this.PatientId = this.data.patientid;
      if (this.data.encounterid)
        this.EncounterId = this.data.encounterid
      if (this.data.element) {
        this.EncounterId = this.data.element.encounters;
        this.PatientId = this.data.element.PatientId;
        this.RecordRequestId = this.data.element.ID;
        this.AddedSections = this.data.element.Sections;
        this.CCDA_HTML = this.data.element.HTMLMessage;
      }
      if (this.data.isdirect) {
        this.isdirect = this.data.isdirect;
      }

    }


  }

  ngOnInit() {
    this.isDataAdded = false;
    this.spinner.show();
    forkJoin(this._PatientformService.getPersonalInfo(Number(this.PatientId)),
      this.schedulerService.searchPatAppointmentDetails(Number(this.PatientId), "", "")
    ).subscribe(([patient, encounter]: any) => {
      this.PatientPersonalInfo = patient;
      // if (this.EncounterId) {
      //   this.PatientVisitDetails = encounter.filter(i => i.encounterid.toUpperCase() == this.EncounterId.toUpperCase());
      //   this.CCDAForm.controls["encounterid"].setValue(this.EncounterId);
      // }
      // else
      this.PatientVisitDetails = encounter.filter(i => i.encounterid != null);// i.encounterid.length > 0);
      this.spinner.hide();
    },
      (err: any) => { console.log(err); this.spinner.hide(); });

    this.Sections = [
      { name: 'ReasonforVisit', value: 'ReasonforVisit' },
      { name: 'SocialHistory', value: 'SocialHistory' },
      { name: 'Problems', value: 'Problems' },
      { name: 'Immunizations', value: 'Immunizations' },
      { name: 'Vitals', value: 'Vitals' },
      { name: 'Medications', value: 'Medications' },
      { name: 'Procedures', value: 'Procedures' },
      { name: 'MedicationAllergies', value: 'MedicationAllergies' },
      { name: 'Plan', value: 'Plan' },
      { name: 'Results', value: 'Results' },
      { name: 'Assessment', value: 'Assessment' },
      { name: 'Functional Status', value: 'FunctionalStatus' },
      { name: 'Cognitive Status', value: 'CognitiveStatus' },
      { name: 'Health Concerns', value: 'HealthConcerns' },
      { name: 'Goals', value: 'Goals' },
      { name: 'Clinical Notes', value: 'clinicalnotes' },
      { name: 'History of Procedures', value: 'historyofprocedures' },
      { name: 'Interventions', value: 'interventions' },
      { name: 'Evolutions', value: 'evolutions' },


    ];
    this.MessageType = [
      { name: 'CCDA', value: 'CCDA' },
      { name: 'Referal Note', value: 'ReferalNote' },
      { name: 'Care Plan', value: 'CarePlan' },

    ];

    this.CCDAForm = this._formBuilder.group({
      Sections: this._formBuilder.array([], [Validators.required]),
      patientId: [this.PatientId],
      encounterid: [this.EncounterId, [Validators.required]],
      userid: [encodeURIComponent(sessionStorage.getItem("userId")).toString()],
      SectionswithComma: [],//this.Sections.map(x => x.value).join(",")
      MessageType: ['CCDA', [Validators.required]],
      ReferralNote: ['']
    });

    if (this.data.element) {
      if (this.data.element.DocumentType)
        this.CCDAForm.controls["MessageType"].setValue(this.data.element.DocumentType);

    }

    const checkArray: FormArray = this.CCDAForm.get('Sections') as FormArray;
    if (this.AddedSections && this.AddedSections != '') {
      this.AddedSections.split(',').forEach(x => {
        checkArray.push(new FormControl(x));
      });
    }
    else {
      this.Sections.forEach(x => {
        checkArray.push(new FormControl(x.value));
      });
    }
  }
  fnSelectedEncounters(encounterid: string) {
    // if (!this.CCDAForm.controls["encounterid"].value)
    //   return false;
    // return this.CCDAForm.controls["encounterid"].value.split(',').filter(i => i.toString().toUpperCase() === encounterid.toUpperCase()).length > 0
  }
  fnAddthisVisit(encounterid: string, event: boolean) {
    if (event == true)
      this.EncounterId = encounterid;
    else
      this.EncounterId = null;
    this.CCDAForm.controls["encounterid"].setValue(this.EncounterId);
    return;


    let encounters = [];// this.EncounterId.split(',');
    if (this.CCDAForm.controls["encounterid"].value)
      encounters = this.CCDAForm.controls["encounterid"].value.split(',');// this.EncounterId.split(",");
    try {
      if (encounters.includes(encounterid))
        encounters = encounters.filter(i => i.toString() != encounterid);
      else
        encounters.push(encounterid);
    }
    catch (e) {
      encounters.push(encounterid);
    }

    this.CCDAForm.controls["encounterid"].setValue(encounters.join(','));

  }
  get getSections(): FormArray {
    return this.CCDAForm.get("Sections") as FormArray
  }
  isSectionAdded(sectionName: string) {
    // return this.CCDAForm.controls["SectionswithComma"].value.split(",").filter(i => i.value == sectionName).length > 0
    return this.getSections.controls.filter(i => i.value == sectionName).length > 0
  }
  onCheckboxChange_All(e: any) {
    const checkArray: FormArray = this.CCDAForm.get('Sections') as FormArray;
    checkArray.clear();
    if (e.target.checked) {
      this.Sections.forEach(ele => {
        checkArray.push(new FormControl(ele.value));
      })
    }
    this.CCDAForm.get('Sections').setValue(checkArray);
  }
  isSectionAdded_All(): boolean {
    const checkArray: FormArray = this.CCDAForm.get('Sections') as FormArray;
    return (this.Sections.length == checkArray.length)
  }
  onCheckboxChange(e: any) {
    const checkArray: FormArray = this.CCDAForm.get('Sections') as FormArray;
    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }
  OnMessageTypeCheckBoxChange(e: any) {
    const MessageType = this.CCDAForm.get('MessageType').value;
    if (e.target.checked)
      this.CCDAForm.get('MessageType').setValue(e.target.value);
    else
      this.CCDAForm.get('MessageType').setValue('')


  }
  fnTransmitRecordRequest() {

  }
  fnShowPreview() {
    var myWindow = window.open("", "MsgWindow", "width=500,height=800");
    myWindow.document.write(this.CCDA_HTML);
  }
  isMessageTypeAdded(Name: string) {
    // return this.CCDAForm.controls["SectionswithComma"].value.split(",").filter(i => i.value == sectionName).length > 0
    return this.CCDAForm.get('MessageType').value == Name;
  }
  onCloseClick() {
    this.dialogRef.close(this.isDataAdded);
  }
  fnGenerateCDA(Messagetype: string) {

    const SectionsList = this.CCDAForm.controls.Sections.value.join(',');
    this.CCDAForm.patchValue({
      SectionswithComma: SectionsList
    });

    this._ccdaService.generateCDA_DirectMessage(this.CCDAForm.value, Messagetype).subscribe(res => {
      this.CCDAResult = res;
      if (!this.isdirect) {
        // The HTML is stored in blob storage, not under the API's Downloads folder,
        // so render the HTML returned in the response instead of building a file URL.
        if (!res.HTMLMessage) {
          this.toastr.error("Unable to generate CDA preview.");
          return;
        }
        const previewUrl = URL.createObjectURL(new Blob([res.HTMLMessage], { type: "text/html" }));
        window.open(previewUrl, "MsgWindow", "width=500,height=800");
        setTimeout(() => URL.revokeObjectURL(previewUrl), 60000);
      }
      else {
        if (this.PatientVisitDetails)
          res.visitDate = this.PatientVisitDetails[0].start;
        res.encounterId = this.PatientVisitDetails[0].encounterid;
        res.type = "xml";
        res.HTMLMessage = 'Downloads\\CCDA' + res.HTMLPath.split('CCDA')[1];
        this.dialogRef.close(res);
      }
    });
  }
  fnSaveRecordRequest() {
    this.CCDAForm.patchValue({
      SectionswithComma: this.CCDAForm.controls.Sections.value.join(',')
    });
    this._ccdaService.AddPatientRecordRequest(this.CCDAForm.value).subscribe(res => {
      this.toastr.success("Added Successfully");
      this.isDataAdded = true;
      this.onCloseClick();
    });

  }
  fnGenerateXDM() {
    this._ccdaService.GetPatientXDM(this.PatientId).subscribe(res => {
      if (this.isdirect) {
        var xdmobject = {
          docdata: res.documentdata,
          type: "zip",
          docname: "XDM_" + this.PatientId + ".zip"
        }
        this.dialogRef.close(xdmobject);
      }
    });
  }

  fnGenerateNHCS(Messagetype: string) {

    const SectionsList = this.CCDAForm.controls.Sections.value.join(',');
    this.CCDAForm.patchValue({
      SectionswithComma: SectionsList
    });

    this._ccdaService.generateNHCPSMessage(this.CCDAForm.value, Messagetype).subscribe(res => {
      this.CCDAResult = res;
      if (!this.isdirect) {
        res.HTMLPath = configuration.clinicTokenUrl + res.HtmlPath;
        window.open(res.HTMLPath, "MsgWindow", "width=500,height=800")

        // var myWindow = window.open("", "MsgWindow", "width=500,height=800");
        // myWindow.document.write(res.HTMLMessage);
        this.dialogRef.close(true);
      }
    });
  }

}
